export const environment = {
    production: false,
    keycloakURL: 'https://monitor.iotbridge.se/auth',
    keycloakRealm: "",
    pystURL: "",
};
